module.exports = __webpack_public_path__ + "img/Fa.afbba64e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/Fa.jpg
// module id = VWLx
// module chunks = 1